import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    bulkAssignUsersEntitlements,
    getAssignUsersEntitlementsProgress,
    stopBulkActions,
} from 'src/openapi/admin/apis/BulkAssignUsersEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import {MODAL_WIDTH} from '../constants';
import {UpdateUsersEntitlementsModal} from '../update-users-entitlements.modal';

import {
    selectAssignUsersEntitlementsBulkUuid,
    selectAssignUsersEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './assign-users-entitlements.slice';
import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';

import type {UpdateEntitiesEntitlementsRelation} from 'src/openapi/admin/models/UpdateEntitiesEntitlementsRelation';

type Props = {
    ids: string[],
    shown: boolean,
    onClose: () => void,
};

export const AssignUsersEntitlementsTool = ({ids, shown, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UpdateEntitiesEntitlementsRelation>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectAssignUsersEntitlementsTask}
            uuidSelector={selectAssignUsersEntitlementsBulkUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(updateEntitiesEntitlementsRelation, options) => (
                apiDispatch(bulkAssignUsersEntitlements({...options, updateEntitiesEntitlementsRelation}))
            )}
            getProgress={id => apiDispatch(getAssignUsersEntitlementsProgress({id}))}
            stopAction={id => apiDispatch(stopBulkActions({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}>
            {({processAction, onCloseModal}) => (
                <UpdateUsersEntitlementsModal
                    ids={ids}
                    mode="ASSIGN"
                    onCloseModal={onCloseModal}
                    processAction={processAction}
                />
            )}
        </BulkActionTool>
    );
};
